import Valkyrie from "@sippy-platform/valkyrie";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

function SelectableCard({ selected, onClick, icon, title, description, disabled = false, img, ...props }) {
  return (
    <Card
      variant="outlined"
      {...props}
      sx={[
        {
          background: "transparent",
          height: "100%",
          "h3 span": {
            mr: 0.5,
            top: 2,
          },
        },
        selected && {
          boxShadow: (theme) => `0 0 0 2px ${theme.vars.palette.primary[500]}`,
          borderColor: "transparent",
          "h3 span": {
            color: "primary.500",
          },
        },
      ]}
    >
      <CardActionArea onClick={onClick} sx={{ height: 1 }} disabled={disabled}>
        <CardContent
          sx={{
            height: 1,
            display: "flex",
            flexDirection: "column",
            alignContent: "flex-start",
          }}
        >
          {img && <img src={img} style={{ marginBottom: 12, borderRadius: 6, width: "100%" }} />}
          <Typography
            gutterBottom
            variant="h6"
            component="h3"
            sx={{
              m: 0,
              fontSize: "1rem",
              opacity: disabled ? 0.5 : 1,
              lineHeight: 1,
            }}
          >
            {icon && <Valkyrie icon={icon} />} {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="textSecondary" component="p" sx={{ fontSize: ".75rem", mt: 0.5 }}>
              {description}
            </Typography>
          )}
          {props.children}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

SelectableCard.propTypes = {
  img: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  icon: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SelectableCard;
